import React from 'react'
import { Form } from 'react-bootstrap'
import { formClasses } from '../../../../sharedLayout/forms'
import { getClassName } from '../../../../../utils/utils'
import { BmiBlockStyle } from './bmiBlockLayout'

type BMIInputProps = {
  label: string
  id: string
  value?: number
  onKeyPress: (e: any) => void
  onChange: (e: any) => void
  extraSpan?: React.ReactNode
}

export const BMIInputLayout = (props: BMIInputProps) => (
  <Form.Group className={getClassName(formClasses, 'formGroupClassName', '')}>
    <Form.Label className={getClassName(formClasses, 'formLabelClassName', '')}>{props.label}</Form.Label>
    <Form.Control
      id={props.id}
      type="number"
      inputMode="numeric"
      pattern="[0-9]*"
      value={props.value}
      onKeyPress={props.onKeyPress}
      onChange={props.onChange}
      className={getClassName(formClasses, 'formInputClassName', '')}
    />
    {props.extraSpan && <span>{props.extraSpan}</span>}
  </Form.Group>
)

type ButtonGroupProps = {
  id: string
  option1: { checked: boolean; onChange: () => void }
  option2: { checked: boolean; onChange: () => void }
}

export const QuestionLayout = (props: ButtonGroupProps & { question: React.ReactNode; style: BmiBlockStyle }) => (
  <li key={props.id} className={getClassName(props.style, 'itemClassName', '')}>
    <div role="group" id={props.id}>
      <label>{props.question}</label>
      <ButtonGroupLayout {...props} />
    </div>
  </li>
)

export const ButtonGroupLayout = ({ id, option1, option2 }: ButtonGroupProps) => (
  <div className="button-group">
    <div className="button-group__option">
      <input
        type="radio"
        name={id}
        id={`${id}-yes`}
        className="button-group__input form__bool"
        value="ja"
        onChange={option1.onChange}
        checked={option1.checked}
      />
      <label className="button-group__label" htmlFor={`${id}-yes`}>
        <span>Ja</span>
      </label>
    </div>
    <div className="button-group__option">
      <input
        type="radio"
        name={id}
        id={`${id}-no`}
        className="button-group__input form__bool"
        value="nee"
        onChange={option2.onChange}
        checked={option2.checked}
      />
      <label className="button-group__label" htmlFor={`${id}-no`}>
        <span>Nee</span>
      </label>
    </div>
  </div>
)
